import { useLocation } from "react-router";
import { useQueryString } from "../Hook";
import consts, { navIndex } from "./consts";

/**
 * Evaluates current location pathname (from useLocation) & query string and returns expected navIndex & filter
 * represented by left main navigation
 * @returns Current navIndex (Or what is supposed to be current navIndex)
 */
export default function useNavIndexFromLocation():
	| { name: string; index: navIndex; }
	| undefined {
	const location = useLocation();
	if (location.pathname === consts.routerPath.home) return { name: "Home", index: "Home" };
	if (location.pathname === consts.routerPath.schedules) return { name: "Schedules", index: "Schedules" };
	if (location.pathname === consts.routerPath.criteria) return { name: "Criteria", index: "Criteria" };
	if (location.pathname === consts.routerPath.inventory) return { name: "Inventory", index: "Inventory" };
	if (location.pathname === consts.routerPath.inventoryUpdates) return { name: "Inventory Updates", index: "InventoryUpdates" };
	if (location.pathname === consts.routerPath.inventoryDisplayRequired) return { name: "Display Required", index: "DisplayRequired"}

	return undefined;
}
